<template lang="html">
  <div class="cart-list flex flex-col gap-2 sm:gap-3">
    <CartItem
      v-for="item in props.value"
      :key="item.id"
      :value="item"
      :attributes-meta="attributesMeta"
      :selectable="props.selectable"
      :selected="props.selectable && props.selected.includes(item.id!)"
      :show-notify="props.showNotify"
      :unit-price="props.lineUnitPrices?.get(item.id!)"
      @remove="emit('remove', $event)"
      @update:selected="
        emit('update:selected', { id: item.id!, value: $event })
      "
      @toggle-notify="emit('toggleNotify', $event)"
    />
  </div>
</template>

<script setup lang="ts">
import type { CartProductListItemDto } from '@repo/api/web/models'

import CartItem from './CartItem.vue'
import type { SelectedChangePayload } from '../../composables/useCartSelection'

const props = withDefaults(
  defineProps<{
    value?: CartProductListItemDto[]
    attributesMeta?: Record<string, object>
    selectable?: boolean
    selected?: number[]
    showNotify?: boolean
    lineUnitPrices?: Map<number, number>
  }>(),
  {
    value: () => [],
    selectable: false,
    selected: () => [],
    showNotify: false,
    lineUnitPrices: () => new Map(),
  },
)
const emit = defineEmits<{
  remove: [productId: number]
  'update:selected': [payload: SelectedChangePayload]
  toggleNotify: [productId: number]
}>()
</script>
